"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGetDeparturesFromStopPlaces = createGetDeparturesFromStopPlaces;
exports.createGetDeparturesFromStopPlace = createGetDeparturesFromStopPlace;
exports.createGetDeparturesFromQuays = createGetDeparturesFromQuays;
exports.createGetDeparturesBetweenStopPlaces = createGetDeparturesBetweenStopPlaces;
exports.createGetDeparturesForServiceJourney = createGetDeparturesForServiceJourney;
exports.getStopPlaceDeparturesDEPRECATED = getStopPlaceDeparturesDEPRECATED;

var _api = require("../api");

var _travelModes = require("../constants/travelModes");

var _utils = require("../utils");

var _query = require("./query");

var _mapper = require("./mapper");

var _config = require("../config");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function createGetDeparturesFromStopPlaces(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getDeparturesFromStopPlaces(stopPlaceIds) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!Array.isArray(stopPlaceIds)) {
      throw new Error("getDeparturesFromStopPlaces takes an array of strings, but got ".concat(_typeof(stopPlaceIds)));
    }

    if (stopPlaceIds.length === 0) {
      return Promise.resolve([]);
    }

    var _params$limit = params.limit,
        limit = _params$limit === void 0 ? 50 : _params$limit,
        _params$timeRange = params.timeRange,
        timeRange = _params$timeRange === void 0 ? 72000 : _params$timeRange,
        _params$start = params.start,
        start = _params$start === void 0 ? new Date() : _params$start,
        limitPerLine = params.limitPerLine,
        _params$includeCancel = params.includeCancelledTrips,
        includeCancelledTrips = _params$includeCancel === void 0 ? false : _params$includeCancel,
        _params$includeNonBoa = params.includeNonBoarding,
        includeNonBoarding = _params$includeNonBoa === void 0 ? false : _params$includeNonBoa,
        whiteListedLines = params.whiteListedLines,
        whiteListedAuthorities = params.whiteListedAuthorities,
        whiteListedModes = params.whiteListedModes,
        rest = _objectWithoutProperties(params, ["limit", "timeRange", "start", "limitPerLine", "includeCancelledTrips", "includeNonBoarding", "whiteListedLines", "whiteListedAuthorities", "whiteListedModes"]);

    var variables = _objectSpread({
      ids: stopPlaceIds,
      includeCancelledTrips: includeCancelledTrips,
      start: start.toISOString(),
      omitNonBoarding: !includeNonBoarding,
      timeRange: timeRange,
      limit: limit,
      limitPerLine: limitPerLine,
      whiteListedLines: whiteListedLines,
      whiteListedAuthorities: whiteListedAuthorities,
      whiteListedModes: whiteListedModes
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getDeparturesFromStopPlacesQuery, variables, config).then(function (data) {
      if (!(data === null || data === void 0 ? void 0 : data.stopPlaces)) {
        throw new Error("Missing data: getDeparturesFromStopPlaces received no data from the API.");
      }

      return data.stopPlaces.map(function (_ref) {
        var estimatedCalls = _ref.estimatedCalls,
            stopPlace = _objectWithoutProperties(_ref, ["estimatedCalls"]);

        return _objectSpread(_objectSpread({}, stopPlace), {}, {
          departures: estimatedCalls.map(_mapper.destinationMapper)
        });
      });
    }).then(function (stopPlaces) {
      return (0, _utils.forceOrder)(stopPlaces, stopPlaceIds, function (_ref2) {
        var id = _ref2.id;
        return id;
      });
    });
  };
}

function createGetDeparturesFromStopPlace(argConfig) {
  var getDeparturesFromStopPlaces = createGetDeparturesFromStopPlaces(argConfig);
  return function getDeparturesFromStopPlace(stopPlaceId, params) {
    return getDeparturesFromStopPlaces([stopPlaceId], params).then(function (stopPlaces) {
      if (!(stopPlaces === null || stopPlaces === void 0 ? void 0 : stopPlaces.length) || !stopPlaces[0]) return [];
      return stopPlaces[0].departures || [];
    });
  };
}

function createGetDeparturesFromQuays(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getDeparturesFromQuays(quayIds) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!Array.isArray(quayIds)) {
      throw new Error("getDeparturesFromQuays takes an array of strings, but got ".concat(_typeof(quayIds)));
    }

    if (quayIds.length === 0) {
      return Promise.resolve([]);
    }

    var _params$limit2 = params.limit,
        limit = _params$limit2 === void 0 ? 30 : _params$limit2,
        limitPerLine = params.limitPerLine,
        _params$timeRange2 = params.timeRange,
        timeRange = _params$timeRange2 === void 0 ? 72000 : _params$timeRange2,
        _params$includeCancel2 = params.includeCancelledTrips,
        includeCancelledTrips = _params$includeCancel2 === void 0 ? false : _params$includeCancel2,
        _params$includeNonBoa2 = params.includeNonBoarding,
        includeNonBoarding = _params$includeNonBoa2 === void 0 ? false : _params$includeNonBoa2,
        _params$start2 = params.start,
        start = _params$start2 === void 0 ? new Date() : _params$start2,
        rest = _objectWithoutProperties(params, ["limit", "limitPerLine", "timeRange", "includeCancelledTrips", "includeNonBoarding", "start"]);

    var variables = _objectSpread({
      ids: quayIds,
      start: start.toISOString(),
      includeCancelledTrips: includeCancelledTrips,
      omitNonBoarding: !includeNonBoarding,
      timeRange: timeRange,
      limit: limit,
      limitPerLine: limitPerLine
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getDeparturesFromQuayQuery, variables, config).then(function (data) {
      if (!data || !(data === null || data === void 0 ? void 0 : data.quays)) {
        throw new Error("Missing data: getDeparturesFromQuays received no data from the API.");
      }

      return data.quays.map(function (_ref3) {
        var estimatedCalls = _ref3.estimatedCalls,
            stopPlace = _objectWithoutProperties(_ref3, ["estimatedCalls"]);

        return _objectSpread(_objectSpread({}, stopPlace), {}, {
          departures: estimatedCalls.map(_mapper.destinationMapper)
        });
      });
    }).then(function (quayDepartures) {
      return (0, _utils.forceOrder)(quayDepartures, quayIds, function (_ref4) {
        var id = _ref4.id;
        return id;
      });
    });
  };
}

function createGetDeparturesBetweenStopPlaces(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getDeparturesBetweenStopPlaces(fromStopPlaceId, toStopPlaceId) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var _params$limit3 = params.limit,
        limit = _params$limit3 === void 0 ? 20 : _params$limit3,
        _params$start3 = params.start,
        start = _params$start3 === void 0 ? new Date() : _params$start3,
        rest = _objectWithoutProperties(params, ["limit", "start"]);

    var variables = _objectSpread({
      from: {
        place: fromStopPlaceId
      },
      to: {
        place: toStopPlaceId
      },
      limit: limit,
      dateTime: start.toISOString(),
      arriveBy: false,
      modes: [_travelModes.BUS, _travelModes.TRAM, _travelModes.RAIL, _travelModes.METRO, _travelModes.WATER, _travelModes.AIR, _travelModes.COACH, _travelModes.CAR]
    }, rest);

    return (0, _api.journeyPlannerQuery)(_query.getDeparturesBetweenStopPlacesQuery, variables, config).then(function (data) {
      var _data$trip;

      if (!data || !(data === null || data === void 0 ? void 0 : (_data$trip = data.trip) === null || _data$trip === void 0 ? void 0 : _data$trip.tripPatterns)) return [];
      return data.trip.tripPatterns.map(function (trip) {
        var _trip$legs = _slicedToArray(trip.legs, 1),
            leg = _trip$legs[0];

        if (!leg) return undefined;
        return (0, _mapper.legToDepartureMapper)(leg);
      }).filter(_utils.isTruthy);
    });
  };
}

function createGetDeparturesForServiceJourney(argConfig) {
  var config = (0, _config.getServiceConfig)(argConfig);
  return function getDeparturesForServiceJourney(id, date) {
    var variables = {
      id: id,
      date: date
    };
    return (0, _api.journeyPlannerQuery)(_query.getDeparturesForServiceJourneyQuery, variables, config).then(function (data) {
      var _data$serviceJourney;

      return ((data === null || data === void 0 ? void 0 : (_data$serviceJourney = data.serviceJourney) === null || _data$serviceJourney === void 0 ? void 0 : _data$serviceJourney.estimatedCalls) || []).map(_mapper.destinationMapper);
    });
  };
}

function getStopPlaceDeparturesDEPRECATED() {
  throw new Error('Entur SDK: "getStopPlaceDepartures" is deprecated, use "getDeparturesForStopPlace" or getDeparturesForStopPlaces instead.');
}